// extracted by mini-css-extract-plugin
module.exports = {"latestProject":"Footer_latestProject__ybkcx"};